// React
// eslint-disable-next-line
import React from 'react';
// core components/views
import translate from 'locales/i18n';
import Dashboard from 'components/page/DashboardPage/DashboardPage.jsx';
import NotFound from 'components/NotFoundPage.jsx';
import Login from 'components/page/LoginPage/LoginPage.jsx';
import Unauthorized from 'components/UnauthorizedPage.jsx';
import AccountImportPage from 'components/page/AccountImportPage/AccountImportPage';
import ControlTower from 'components/page/ControlTowerPage/ControlTowerPage';
import HighlightsItems from 'components/page/HighlightsItemsPage/HighlightsItems';
import ProxiesManager from 'components/page/ProxyPage/ProxiesManagerPage';
import AccountsManager from 'components/page/AccountManagerPage/AccountsManagerPage';
import SitesManager from 'components/page/SiteManagerPage/SitesManagerPage';
import UsersManager from 'components/page/UserManagerPage/UsersManagerPage';
import Performances from 'components/page/PerformancePage/PerformancesPage';
import UserActions from 'components/page/UserActionPage/UserActionsPage';
import CatalogPage from 'components/page/CatalogPage/CatalogPage';
// Material UI Components
import Icon from '@mui/material/Icon';
// Theme
import theme from 'assets/theme/theme.js';
// PCP Components
import CustomIcon from 'components/commons/CustomIcon';

const routes = [
    {
        path: '/dashboard',
        sidebarName: translate.i18n('DASHBOARD'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>dashboard</Icon>,
        component: Dashboard,
        displayLayout: true
    },
    {
        path: '/control-tower',
        sidebarName: translate.i18n('CONTROL_TOWER'),
        icon: <CustomIcon className='fas fa-chess-rook' style={{ color: theme.palette.green.dark }} />,
        dashboardIcon: <CustomIcon className='fas fa-chess-rook' style={{ display: 'flex', fontSize: 50, color: 'white' }} />,
        component: ControlTower,
        displayLayout: true,
        rightName: 'CONTROL_TOWER'
    },
    {
        path: '/spe_highlights_items',
        sidebarName: translate.i18n('SPE_HIGHLIGHTED_ITEMS'),
        icon: <CustomIcon className='fas fa-lightbulb' style={{ color: theme.palette.green.dark }} />,
        dashboardIcon: <CustomIcon className='fas fa-lightbulb' style={{ display: 'flex', fontSize: 50, color: 'white' }} />,
        component: HighlightsItems,
        displayLayout: true,
        rightName: 'SPE_HIGHLIGHTED'
    },
    {
        path: '/proxies',
        sidebarName: translate.i18n('PROXIES'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>vpn_lock</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >vpn_lock</Icon>,
        component: ProxiesManager,
        displayLayout: true,
        rightName: 'PROXY'
    },
    {
        path: '/accounts',
        sidebarName: translate.i18n('ACCOUNTS_MANAGER'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>folder_shared</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >folder_shared</Icon>,
        component: AccountsManager,
        displayLayout: true,
        rightName: 'ACCOUNT'
    },
    {
        path: '/sites',
        sidebarName: translate.i18n('SITES_MANAGER'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>language</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >language</Icon>,
        component: SitesManager,
        displayLayout: true,
        rightName: 'SITE'
    },
    {
        path: '/users',
        sidebarName: translate.i18n('USERS_MANAGER'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>account_box</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >account_box</Icon>,
        component: UsersManager,
        displayLayout: true,
        rightName: 'USER'
    },
    {
        path: '/perfomances',
        sidebarName: translate.i18n('PERFORMANCES'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>trending_up</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >trending_up</Icon>,
        component: Performances,
        displayLayout: true,
        rightName: 'PERF'
    },
    {
        path: '/catalogs',
        sidebarName: translate.i18n('CATALOGS'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>menu_book</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >menu_book</Icon>,
        component: CatalogPage,
        displayLayout: true,
        rightName: 'CATALOG'
    },
    {
        path: '/account/import',
        component: AccountImportPage,
        displayLayout: true,
        rightName: 'ACCOUNT'
    },
    {
        path: '/user_actions',
        sidebarName: translate.i18n('USER_ACTIONS'),
        icon: <Icon style={{ color: theme.palette.green.dark }}>touch_app</Icon>,
        dashboardIcon: <Icon style={{ display: 'flex', fontSize: 50, color: 'white' }} >touch_app</Icon>,
        component: UserActions,
        displayLayout: true
    },
    {
        path: '/login',
        component: Login,
        displayLayout: false
    },
    {
        path: '/unauthorized',
        component: Unauthorized,
        displayLayout: false
    },
    {
        redirect: true,
        path: '/',
        to: '/dashboard'
    },
    {
        path: '*',
        component: NotFound,
        displayLayout: false
    },
];

export default routes;
